import { Component, OnInit, Injector, HostListener, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { WorkOrdersService } from '../../work-orders.service';
import { GAWorkOrderService } from '../../../ve.service';
import { CgpConfirmationDialogService } from '../../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { FileUploadService } from '../../work-order-file-upload/file-upload.service';

@Component({
  selector: 'app-ga-wo-add',
  templateUrl: './ga-wo-add.component.html',
  styleUrls: ['../../work-orders.component.scss']
})
export class GaWoAddComponent implements OnInit, OnDestroy {
  appCardTitle: string;
  router: Router;
  service: WorkOrdersService;
  gaWorkOrderService: GAWorkOrderService;
  cgpConfirmationDialogService: CgpConfirmationDialogService;
  fileUploadService: FileUploadService;
  isCancel = false;

  constructor(injector: Injector) {
    this.appCardTitle = 'Add New GA Work Order';
    this.service = injector.get(WorkOrdersService);
    this.gaWorkOrderService = injector.get(GAWorkOrderService);
    this.cgpConfirmationDialogService = injector.get(CgpConfirmationDialogService);
    this.fileUploadService = injector.get(FileUploadService);
    this.router = injector.get(Router);
  }

  ngOnInit() {
    //this is kept empty on purpose
  }

  ngOnDestroy() {
    this.service.resetForm();
    this.service.enableForm();
    this.service.resetGridView();
  }

  onTabSelect(event) {
    if (event.index === 1) { this.fileUploadService.fileType = 'Instructions' }
    else if (event.index === 2) { this.fileUploadService.fileType = 'AditionalInfo' } 
    this.fileUploadService.getFiles();
  }

  saveOrSubmit(event: any) {
    const action = event.currentTarget.id;
    const workOrder = this.getGAWorkOrder();
    this.service.saveOrSubmit(action, workOrder);
  }

  back = () => {
    const workOrder = this.getGAWorkOrder();
    this.service.back(workOrder, false);
  }

  cancel() {
    const workOrder = this.getGAWorkOrder();
    this.service.back(workOrder, true);
  }

  /**
   * Build GA Work Order object to send in request
   * payload for either Submit or Save actions
   */
  getGAWorkOrder(): any {
    const workOrder = this.service.workOrderDetailsForm.value;
    workOrder.AddInfoCategories = workOrder.AddInfoCategories
      ? workOrder.AddInfoCategories
      : [];
    workOrder.ToolingOperatorInterfaces = workOrder.ToolingOperatorInterfaces
      ? workOrder.ToolingOperatorInterfaces
      : [];
    delete workOrder.ProgramDetailId;
    return workOrder;
  }

  public isFormValid = (): boolean => {
    const isWoDetailsValid = this.service.workOrderDetailsForm.valid;
    const isAddInfoValid = Boolean(this.service.additionalInfoForm.value.Id) ?
    this.service.isAddInfoFormValid.getValue() && this.service.additionalInfoForm.valid :
    this.service.isAddInfoFormValid.getValue();
    const isDelObjValid = this.service.isDeliverablesObjFormValid && this.service.deliverablesObjectivesForm.valid;
    return isWoDetailsValid && isAddInfoValid && isDelObjValid;
  }

}
